(ns frontend.domain.fundraising-opportunity.actions
  (:require
   [frontend.actions.fundraising-opportunity :as fundraising-opportunity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.view.entity :as f-entity]
   [frontend.zap-time :as zap-time]))

(defn resurrect!
  [entity]
  (fundraising-opportunity-actions/*->resurrect!
   {:fundraising-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn won!
  [{:keys [entity reset-focus!]}]
  (let [fo-owner (:fundraising-opportunity/owner entity)
        fo-credit (:fundraising-opportunity/credit entity)]
    (f-entity/open-creator!
     :entity.type/fund-commitment
     (merge
      {:start-value   (merge
                       {:fund-commitment/investor (:fundraising-opportunity/investor entity)
                        :fund-commitment/cur-committed-amount
                        (:fundraising-opportunity/cur-commitment-amount entity)
                        :fund-commitment/cur-committed-amount--sym
                        (:fundraising-opportunity/cur-commitment-amount--sym entity)}
                       (when (f-permissions/field-write-access? :fund-commitment/owner
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/owner (or (session/active-account-id fo-owner)
                                                     (:db/id @session/account))})
                       (when (f-permissions/field-write-access? :fund-commitment/committed-date
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/committed-date (zap-time/now)})
                       (when (f-permissions/field-write-access? :fund-commitment/credit
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/credit (or (session/active-account-id fo-credit)
                                                      (session/active-account-id fo-owner)
                                                      (:db/id @session/account))})
                       (when (f-permissions/field-write-access? :fund-commitment/won-by
                                                                :entity.type/fund-commitment
                                                                nil)
                         {:fund-commitment/won-by (:db/id @session/account)})
                       (when-let [fund (or (:fundraising-opportunity/fund entity)
                                           (->> entity
                                                :fundraising-opportunity/pipeline
                                                (get @session/entities)
                                                :pipeline/fund))]
                         (when (f-permissions/field-write-access? :fund-commitment/fund
                                                                  :entity.type/fund-commitment
                                                                  nil)
                           {:fund-commitment/fund fund})))
       :on-processed! (fn [{:keys [new-entity-id close-cb!]}]
                        (fundraising-opportunity-actions/*->won!
                         {:fundraising-opportunity-id (:db/id entity)
                          :fund-commitment-id         new-entity-id}
                         (fn [_]
                           (close-cb!))
                         (fn [err]
                           (logging/error "Failed to set froppo as Won " err))))}
      (when reset-focus!
        {:reset-focus! reset-focus!})))))
